import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import { Typography } from '../../../atoms/typography/Typography';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';

const CompareBottomBar = ({
  // categoryId,
  // compareSystemsPageUrl,
  compareSystemsStaticPageUrl,
  compareSystems,
  onSystemCompare,
  onCompareClick,
  t,
}) => {
  const isVisible = compareSystems?.length > 0;
  // const comparedSystemsUrl = compareSystems?.map((item) => item.systemUrl);

  if (!isVisible) {
    return null;
  }

  const comparedSystemsObj = compareSystems.sort((a, b) =>
    a.id.localeCompare(b.id)
  );

  const systemUrlsForCompare = [];
  comparedSystemsObj.forEach((item) => {
    systemUrlsForCompare.push(item.systemUrl);
  });

  const compareStaticUrl = `${compareSystemsStaticPageUrl}${systemUrlsForCompare?.join('-vs-')}/`;

  // const compareUrl = `${compareSystemsPageUrl}?systems=${comparedSystemsUrl?.join(
  //   ','
  // )}&category=${categoryId}`;

  return (
    <div className="fixed right-0 left-0 bottom-0 z-40 flex items-center justify-center bg-white shadow-xl overflow-hidden">
      {isVisible && (
        <div className="w-full h-auto md:h-28 bg-white flex flex-col md:flex-row justify-center items-center max-w-6xl px-8 py-2 gap-2 md:gap-24">
          <Stack>
            {compareSystems.map((item) => (
              <Row
                className="w-full justify-between gap-20 items-center"
                key={item.id}
              >
                <Typography textAlign="left" fontVariant="h8">
                  {item.systemName}
                </Typography>
                <button
                  type="button"
                  onClick={() => onSystemCompare({ id: item.id })}
                  className="bg-white min-w-fit h-fit text-customGray-900 text-sm border rounded-[48px] border-customGray-300 py-1 px-4 global-hover"
                >
                  {t('comparePreview.remove')}
                </button>
              </Row>
            ))}
          </Stack>
          <Stack>
            <LinkButton
              href={compareStaticUrl}
              label={t('comparePreview.btn')}
              clickable={compareSystems.length === 2}
              variant="primary-filled"
              className="max-w-sm self-end text-clamp-lg p-2 md:p-4 text-center"
              onClick={() => {
                onCompareClick(comparedSystemsObj, compareStaticUrl);
              }}
            />
          </Stack>
        </div>
      )}
    </div>
  );
};

export default CompareBottomBar;
